<template>
  <div class="d-flex justify-content-between flex-fill">
    <ul class="navbar-nav mr-auto">
      <li>
        <h4> {{ this.headerTitle }} </h4>
      </li>
    </ul>
    <ul class="navbar-nav mr-right">
      <li>
        <button class="efedros-menu-btn" v-b-toggle.sidebar-1>
          <b-icon icon="list"></b-icon>
          {{ this.buttonName }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "NavLinksUser",
  data() {
    return {
      headerTitle: "Ηλεκτρονική Εφαρμογή Αποστολής Ειδοποίησης Εφέδρου",
      buttonName: "Ενέργειες"
    }
  }
}
</script>

<style scoped>

.navbar-nav {
  color: white !important;
  align-items: center;
  margin-left: 20px;
}

.navbar-expand-lg .navbar-nav .dropdown-menu {
  background: #0072C6 !important;
  color: white;
}

@media (max-width: 991px) {
  .fixed-top >>> .b-sidebar{

    height: calc(100% - 100px);
    overflow: auto;
  }
}

.fixed-top >>> .b-sidebar{
  margin-top: 104px;
}

.breadcrumb > li + li:before {
  content: unset;
}

.efedros-menu-btn {

  background-color:transparent;
  border: 1px solid white;
  border-radius: 3px;
  color: white;
  height: 50px;
  font-size: 24px;
  padding-left: 20px;
  padding-right: 20px;
  margin-right: 20px;
}

.efedros-menu-btn:hover {

  background-color:white;;
  border: 1px solid white;
  color: #2872C6;
}

</style>